import {
  STOCK_MASSIVE_UPLOAD_CANCEL,
  STOCK_MASSIVE_UPLOAD_FULL_CANCEL
} from './constants';
import initialState from './initialState'

export function cancelMassiveUpload(fullCancel) {
  return (dispatch) => {
    dispatch({
      type: fullCancel ? STOCK_MASSIVE_UPLOAD_FULL_CANCEL : STOCK_MASSIVE_UPLOAD_CANCEL,
    });
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_MASSIVE_UPLOAD_FULL_CANCEL:
      return {
        ...state,
        ...initialState,
      };

      case STOCK_MASSIVE_UPLOAD_CANCEL:
        return {
          ...state,
          massiveUploadPending: false,
        };

    default:
      return state;
  }
}
